/* eslint-disable @typescript-eslint/no-explicit-any */

import { getUserType } from './cachedUser';

declare function clarity(action: string, ...args: unknown[]): void;

function safe(action: string, ...args: unknown[]) {
  try {
    if (typeof clarity === 'function') clarity(action, ...args);
  } catch {}
}

export function identifyUser(userId: string, userType: string, societyId?: string | number) {
  safe('identify', userId, undefined, undefined, userType);
  safe('set', 'user_type', userType);
  if (societyId != null) safe('set', 'society_id', String(societyId));
}

export function trackPageView(route: string, title: string, userType?: string) {
  safe('event', 'page_view');
  safe('set', 'page_route', route);
  safe('set', 'page_title', title);
  if (userType) safe('set', 'user_type', userType);
}

export function trackEvent(name: string, metadata?: Record<string, string | number | boolean>) {
  safe('event', name);
  // Role on every event so funnels can be segmented even before identifyUser ran.
  const role = getUserType();
  if (role) safe('set', 'user_type', role);
  if (metadata) {
    // Clarity tags are session-wide, not per-event, so namespace each key by
    // event name — otherwise generic keys (status, source, mode) from different
    // features overwrite/mix in the same session.
    Object.entries(metadata).forEach(([key, value]) => safe('set', `${name}.${key}`, String(value)));
  }
}
